import { useDialog } from '../composables/useDialog'

export default {
    install(app) {
        const dialog = useDialog()

        // Méthodes globales pour alert
        app.config.globalProperties.$alert = dialog.showAlert
        app.config.globalProperties.$confirm = dialog.showConfirm

        // Raccourcis
        app.config.globalProperties.$dialog = {
            alert: dialog.alert,
            confirm: dialog.confirm,
            showAlert: dialog.showAlert,
            showConfirm: dialog.showConfirm
        }

        // Provide pour Composition API
        app.provide('dialog', dialog)
    }
}
